RivalIQ.apps.Shell.module('mixins', function (mixins, App, Backbone, Marionette, $, _, s, window) {

    'use strict';

    function objectToAttributes(obj) {

        return _.map(obj, function (v, k) {

            return [k, v].join('=');
        }).join(' ');
    }

    function configToAttributes(obj, prefix) {

        return _.reduce(obj, function (memo, v, k) {

            const name = _.compact([prefix, k]).join('-');

            if (_.exists(v)) {

                memo[name] = v;
            }

            return memo;
        }, {});
    }

    mixins.Navigable = {
        templateHelpers: function () {

            const result = {
                s: s,

                disabled: function () {
                    const data = this;
                    return (RivalIQ.state.account.trialExpired() && !data.enabledForExpired) || (RivalIQ.state.account.isCancelled() && !data.enabledForCancelled);
                },

                url: function () {

                    const data = this;
                    const navigation = data.navigation;
                    let url = _.result(navigation, 'url');
                    const pathname = window.location.pathname;
                    const baseUrl = _.result(navigation, 'baseUrl');

                    // only if we have a base URL, a URL, and we are not already
                    // on the base URL page should we construct our own relative URL
                    if (baseUrl && !_.isUndefined(url)) {
                        if (_.isRegExp(baseUrl)) {
                            url = _.get(pathname.match(baseUrl), [0], '') + url;
                        } else if (pathname !== baseUrl) {
                            url = baseUrl + url;
                        }
                    }

                    return url;
                },

                _urlAttr: function () {

                    const me = this;
                    const attr = {};
                    const url = me.url();

                    if (url) {
                        attr.href = url;
                    }

                    return attr;
                },

                _dataAttrs: function () {

                    const me = this;
                    const data = _.result(me.navigation, 'data');
                    return configToAttributes(data, 'data');
                },

                dataAttrs: function () {

                    const me = this;
                    return objectToAttributes(me._dataAttrs());
                },

                _attrs: function () {

                    const me = this;
                    const config = _.reduce(['id', 'class'], function (memo, k) {

                        memo[k] = _.result(me, k);
                        return memo;
                    }, {});
                    return configToAttributes(config);
                },

                allAttrs: function () {

                    const me = this;
                    return _.extend({}, me._dataAttrs(), me._attrs(), me._urlAttr());
                },

                attrs: function () {

                    const me = this;
                    return objectToAttributes(me.allAttrs());
                }
            };

            return result;
        }
    };

}, window.s, window);
